/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Directive, OnInit, inject } from '@angular/core';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { UserService } from 'src/app/user/services';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'dxi-column[biz-grid-user]'
})
export class BizUserColumnDirective implements OnInit {
    private column = inject(DxiColumnComponent);
    private userService = inject(UserService);

    ngOnInit(): void {
        this.column.allowEditing = false;
        this.column.dataType = 'string';
        this.column.formItem = { visible: false };
        this.column.calculateDisplayValue = this.getUserName;
    }

    getUserName = (rowData) => {
        const dataField = this.column.dataField;
        const userId = this.getPropertyValue(dataField, rowData);
        return userId ? this.userService.getSimpleUser(userId)?.DisplayName ?? `${userId}` : '';
    };

    getPropertyValue(path: string, obj: any): any {
        return path.split('.').reduce((prev: any, curr: string) => prev ? prev[curr] : null, obj || self);
    }
}
